import React from 'react';
import { Select as SelectCore, ISelectProps as ISelectPropsCore } from '../core/select';

import normalStyles from './select.module.scss';
import transparantStyles from './select-filter.module.scss';

export interface ISelectProps extends ISelectPropsCore {
	variant?: 'normal' | 'filter';
}

export const Select = (props: ISelectProps): React.JSX.Element => {
	const styles = props.variant === 'filter' ? transparantStyles : normalStyles;

	return <SelectCore {...props} propStyles={styles} fixCrossBrowserStyling />;
};

export default Select;
